import React from 'react';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import {withTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import InputTextComponent from '../components/inputs/InputTextComponent';
import DriverModel from '../model/DriverModel';
import DivContainer from '../components/DivContainer';
import {ActionButton} from '../components/ActionButton';
import DriverService from '../services/DriverService';
import InputCheckboxComponent from '../components/inputs/InputCheckboxComponent';
class DriverDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new DriverService());
        this.state = {
            elementId: props.elementId,
            element: new DriverModel(),
            viewMode: this.props.viewMode,
        };
        this.handleDelete = this.handleDelete.bind(this);
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    prepareFooter() {
        const {t} = this.props;
        return (
            <div className='footer-dialog-button-container'>
                <div className='left-footer-dialog-button-container'>
                    {this.state.viewMode === 'EDIT' ? (
                        <ActionButton
                            label={t('driver.deleteButton')}
                            variant='button cancel-button red'
                            handleClick={(e) => {
                                if (e) {
                                    e.preventDefault();
                                }
                                this.setState({viewMode: 'DELETE', closable: false});
                            }}
                        />
                    ) : null}
                </div>
                <ActionButton
                    label={t('details.cancel')}
                    variant={this.state.viewMode === 'DELETE' ? 'button cancel-button red' : 'button cancel-button white'}
                    handleClick={this.props.onHide}
                />
                <ActionButton
                    label={this.state.viewMode === 'NEW' ? t('driver.addButton') : t('details.saveChanges')}
                    variant='button save-button blue'
                    handleClick={this.handleFormSubmit}
                    rendered={this.state.viewMode !== 'DELETE'}
                />
                <ActionButton
                    label={t('details.deleteConfirmationButton')}
                    variant='button save-button fullred'
                    handleClick={this.handleDelete}
                    rendered={this.state.viewMode === 'DELETE'}
                />
            </div>
        );
    }
    handleDelete(e) {
        if (e) {
            e.preventDefault();
        }
        const {t} = this.props;
        this.blockUi();
        this.service
            .delete(this.state.element)
            .then((response) => {
                this.blockUi();
                this.persistMessage('success', '', t('driver.deleteDriverSuccess'));
                if (this.props.afterSave) {
                    this.props.afterSave();
                }
            })
            .catch((err) => {
                this.persistMessage('error', '', t('error.deleteDriverError'));
                if (this.props.afterSave) {
                    this.props.afterSave();
                }
            });
    }
    renderHeader() {
        const {t} = this.props;
        return (
            <DivContainer colClass='col-12 transaction-dialog-header'>
                <DivContainer colClass='col-12'>
                    <label>
                        {this.state.viewMode === 'NEW'
                            ? `${t('driver.addHeader')}`
                            : this.state.viewMode === 'EDIT'
                            ? `${t('driver.editHeader')}`
                            : `${t('driver.deleteHeader')}`}
                    </label>
                </DivContainer>
            </DivContainer>
        );
    }
    updateElement(data) {
        this.setState(
            {
                element: DriverModel.copy(data),
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }
    setElement() {
        if (this.props.element) {
            this.updateElement(this.props.element);
        }
    }
    getContainerListName() {
        return 'driver-list-container';
    }

    getAddSucces() {
        const {t} = this.props;
        return t('driver.addDriverSuccess');
    }

    getUpdateSucces() {
        const {t} = this.props;
        return t('driver.updateDriverSuccess');
    }
    createOrUpdate() {
        const {element} = this.state;
        this.scrollToTop();
        if (this.props._isMounted) {
            if (element.sapId === undefined || element.sapId === null) {
                this.service
                    .add(element)
                    .then((response) => {
                        this.blockUi();
                        this.persistMessage('success', '', this.getAddSucces(response));
                        if (this.props.afterSave) {
                            this.props.afterSave();
                        }
                    })
                    .catch((err) => {
                        this.persistMessage('error', '', err.message);
                        if (this.props.afterSave) {
                            this.props.afterSave();
                        }
                    });
            } else {
                this.service
                    .update(element)
                    .then((response) => {
                        this.blockUi();
                        this.persistMessage('success', '', this.getUpdateSucces(response));
                        if (this.props.afterSave) {
                            this.props.afterSave();
                        }
                    })
                    .catch((err) => {
                        this.persistMessage('error', '', err.message);
                        if (this.props.afterSave) {
                            this.props.afterSave();
                        }
                    });
            }
        }
    }

    renderDetails() {
        const {t} = this.props;
        return this.state.viewMode === 'DELETE' ? (
            <DivContainer>
                <label id={`delete-driver-label-id`} className='p-label' htmlFor={'delete-driver'} style={{width: '100%'}}>
                    {t('details.deleteConfirmation')}
                </label>
                <span
                    aria-label={t('details.deleteConfirmation')}
                    aria-labelledby={`delete-driver--label-id`}
                    className={`p-inputtext-view icon_text element-to-remove`}
                >
                    {this.state.element.firstName} {this.state.element.lastName}
                </span>
            </DivContainer>
        ) : (
            <React.Fragment>
                <DivContainer colClass='row'>
                    <InputTextComponent
                        id='firstName'
                        name='firstName'
                        label={t('driver.firstName')}
                        colClass='col-md-6'
                        value={this.state.element.firstName}
                        validator={this.validator}
                        validators='required|alpha_space|max:50'
                        onChange={this.handleChange}
                        viewMode={this.state.viewMode}
                        keyfilter={/^[A-ZĄĆĘŁŃÓŚŹŻąćęłńóśźż\s]*$/i}
                    />

                    <InputTextComponent
                        id='lastName'
                        name='lastName'
                        label={t('driver.lastName')}
                        colClass='col-md-6'
                        value={this.state.element.lastName}
                        validator={this.validator}
                        validators='required|alpha_space_dash|max:50'
                        onChange={this.handleChange}
                        viewMode={this.state.viewMode}
                        keyfilter={/^[A-ZĄĆĘŁŃÓŚŹŻąćęłńóśźż\s-]*$/i}
                    />
                </DivContainer>
                <DivContainer colClass='row mt-4'>
                    <InputTextComponent
                        id='pesel'
                        name='pesel'
                        label={t('driver.pesel')}
                        colClass='col-md-6'
                        value={this.state.element.pesel}
                        validator={this.validator}
                        validators='required|pesel'
                        onChange={this.handleChange}
                        viewMode={this.state.viewMode}
                        keyfilter={/^[0-9]*$/i}
                    />
                    <InputTextComponent
                        id='documentNumber'
                        name='documentNumber'
                        label={t('driver.documentNumber')}
                        colClass='col-md-6'
                        value={this.state.element.documentNumber}
                        validator={this.validator}
                        validators='required|alpha_num|max:50'
                        onChange={this.handleChange}
                        viewMode={this.state.viewMode}
                        keyfilter={/^[A-Z0-9]*$/i}
                    />
                </DivContainer>
                <DivContainer colClass='row mt-4'>
                    <InputCheckboxComponent
                        id={`own`}
                        name='own'
                        label={t('driver.isNotOwn')}
                        labelOnRight
                        value={this.state.element.own}
                        validator={this.validator}
                        onChange={this.handleChange}
                        viewMode={this.state.viewMode}
                        validators='not_required'
                        negated
                    />
                </DivContainer>
            </React.Fragment>
        );
    }
}

DriverDialog.defaultProps = {
    currentUser: undefined,
    viewMode: 'VIEW',
    visible: false,
    stationId: undefined,
};

DriverDialog.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    currentUser: PropTypes.object,
    editUrl: PropTypes.string,
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    elementId: PropTypes.number,
    stationId: PropTypes.number,
};

export default withTranslation()(DriverDialog);
